export default {
  FREEMIUM: 'freemium',
  PREMIUM: 'premium',
}
